import { render } from "./FormUpdateCompany.vue?vue&type=template&id=6fb7f04d&scoped=true"
import script from "./FormUpdateCompany.vue?vue&type=script&lang=js"
export * from "./FormUpdateCompany.vue?vue&type=script&lang=js"

import "./FormUpdateCompany.vue?vue&type=style&index=0&id=6fb7f04d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb7f04d"]])

export default __exports__